import SessionEventProto from "../session-event-proto"
import {PAGE_NAME_CHANGED} from "../../../app/project/page/components/title/page-title";

export default class SessionDocumentDelta extends SessionEventProto {

    private header: any

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.header     = {
            document    : sessionEvent.document,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.data.name) {
            gd.bus.triggerEvent(PAGE_NAME_CHANGED, this.data.name)
        }

        // do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) {
            // console.log("same user -> ignore");
            return false;
        }

        if (_.isEmpty(this.data)) return // no data in event then nothing should be done about it (noticed when deadline is set to same value)
        if (this.isDifferentCompany()) return false

        gd.modelBus.newUpdate('document', this.method, this.header.document.id, this.data, this.header)
    }
};
